import logger from '../utils/rbmc.logger';
import sortProducts from './rbmc.sort-products';
import priceSlider from './rbmc.price-slider';
import browserBack from './rbmc.browser-back';

const plp = {
    fetchFragment(url) {
        logger.log(`Fetch products ... = ${url}`);
        return $.ajax({
            url:    url,
            method: 'GET',
            cache:  false
        });
    },
    replaceHeadline(data) {
        let headline = $(data).filter('#plp__fragment__headline').html();
        $('#js-subshop-headline').html(headline);
    },
    replaceFilterBar(data) {
        $('#js-filter-bar--desktop').html($(data).find('#js-filter-bar--desktop').html());
        $('#js-filter-bar--mobile').html($(data).find('#js-filter-bar--mobile').html());
    },
    replaceFacets(data) {
        let facets = $(data).find('#js-facets').html();
        if (facets) {
            $('#js-facets').html(facets);
            sortProducts.buildSelectMenu();
            sortProducts.bindHandler();
            priceSlider.buildPriceSlider();
        } else {
            priceSlider.irsInstance.update({
                'block': false
            });
        }
    },
    exchangeProducts(data) {
        let newProducts = $(data).filter('#plp__fragment__products').html();
        $('#plp__grid').html(newProducts);
    },
    appendProducts(data) {
        let newProducts = $(data).filter('#plp__fragment__products').html();
        $('#plp__grid').append(newProducts);
    },
    replacePagination(data) {
        let newCounter = $(data).filter('#plp__fragment__product-pagination').html();
        let backUrl    = $(data).filter('#plp__back-url').data('backUrl');

        browserBack.setCurrentBackUrl(backUrl);
        $('#plp__product-pagination').replaceWith(newCounter);
    },
    addAppliedFacetsMobile() {
        let priceSlider = document.querySelector('#range-slider--mobile');

        // render applied values of the mobile price slider
        if (priceSlider) {
            let priceSliderData = priceSlider.dataset,
                $facetHeader    = $('.js-mfacet__sub--show-price');

            // after the clearing of the facets the backend sends an empty 'to' and 'from' value
            let sliderCorruptPosition = priceSliderData.from === '' || priceSliderData.to === '';
            // take 'correct' values from the applied facets
            let lowerBound            = $('#js-applied-facet__lowerBound').data('value');
            let upperBound            = $('#js-applied-facet__upperBound').data('value');
            let noBounds              = !lowerBound && !upperBound;

            function renderOutput() {
                return `${lowerBound || priceSliderData.min} - ${upperBound || priceSliderData.max} ${RedBull.config.currencySymbol}`;
            }

            // render applied priceslider values. Another approach would be to check the URL if there are parameters from the slider
            if (sliderCorruptPosition || noBounds) {
                $facetHeader.find('.js-mfacet-item__selection').text('');
                $facetHeader.removeClass('mfacet-item--active');
            } else {
                $facetHeader.find('.js-mfacet-item__selection').html(renderOutput());
                $facetHeader.addClass('mfacet-item--active');
            }
        }

        // render applied values from all other facets. Priceslider has his own treatment
        $('#facet__overlay--facets').find('.facet__overlay').not('.facet__overlay--priceslider').each((index, element) => {
            let $element       = $(element),
                $facetHeader   = $element.prev('.mfacet-item'),
                selectedFacets = [];

            $element.find('.dropdown-item--active .dropdown-item__name').each((index, element) => {
                selectedFacets.push(element.innerText);
            });

            if (selectedFacets.length) {
                $facetHeader.addClass('mfacet-item--active');
            } else {
                $facetHeader.removeClass('mfacet-item--active');
            }
            $facetHeader.find('.js-mfacet-item__selection').text(selectedFacets.join(', '));
        });
    },
    addAppliedFacetsDesktop() {
        // render applied values from all other facets

        $('#js-filter-bar--desktop').find('.dropdown-menu--facet').each((index, element) => {
            let $element = $(element);

            // if there is one active item in the list render the clear button
            if ($element.find('.dropdown-item--active').length) {
                $element.prev('.dropdown-toggle').addClass('dropdown-toggle--active');
            } else {
                $element.prev('.dropdown-toggle').removeClass('dropdown-toggle--active');
            }

            // special treatment for priceslider
            if ($element.hasClass('dropdown-menu--slider-facet')) {
                if ($('#js-applied-facet__lowerBound').length || $('#js-applied-facet__upperBound').length) {
                    $element.prev('.dropdown-toggle').addClass('dropdown-toggle--active');
                }
            }
        });
    },
    addOverflowIndicator() {
        $('.dropdown-menu__scroller').each((index, element) => {
            let $parent = $(element).parent();

            $parent.addClass('dropmenu--overflow-test');
            if (element.scrollHeight > element.offsetHeight) {
                $parent.addClass('dropmenu--overflown');
            }
            $parent.removeClass('dropmenu--overflow-test');
        });
    }
};

export default plp;
